import { Tooltip, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { Iconify } from 'src/components';

// WA-consistent blue for "read" ticks. Using the theme's cyan (info.main
// = #00B8D9 in this codebase) would read too teal next to the green sent
// bubble. #34B7F1 is already WA-native and stays consistent with the
// existing palette tokens — not a new colour introduction, just preserved.
const READ_BLUE = '#34B7F1';

const StatusIcon = ({ status, updatedTimestamp }) => {
    if (status === 'sending' || status === 'queued') {
        return (
            <CircularProgress size={10} sx={{ ml: '0.3rem', color: 'text.disabled' }} />
        );
    }

    if (status === 'failed' || status === 'error') {
        return (
            <Tooltip placement="bottom" title="Failed to send">
                <Iconify
                    icon="mdi:alert-circle"
                    sx={{
                        color: '#FF5630',
                        width: '1rem',
                        height: '1rem',
                        ml: '0.2rem',
                    }}
                />
            </Tooltip>
        );
    }

    const commonProps = {
        placement: 'bottom',
        title: updatedTimestamp,
    };

    if (status === 'read') {
        return (
            <Tooltip {...commonProps}>
                <Iconify
                    icon="charm:tick-double"
                    sx={{
                        color: READ_BLUE,
                        width: '1rem',
                        height: '1rem',
                        cursor: 'pointer',
                        ml: '0.2rem',
                    }}
                />
            </Tooltip>
        );
    }

    if (status === 'delivered') {
        return (
            <Tooltip {...commonProps}>
                <Iconify
                    icon="charm:tick-double"
                    sx={{
                        color: 'text.disabled',
                        width: '1rem',
                        height: '1rem',
                        ml: '0.2rem',
                    }}
                />
            </Tooltip>
        );
    }

    // sent / undefined / unknown → single grey tick
    return (
        <Tooltip {...commonProps}>
            <Iconify
                icon="charm:tick"
                sx={{
                    color: 'text.disabled',
                    width: '1rem',
                    height: '1rem',
                    ml: '0.2rem',
                }}
            />
        </Tooltip>
    );
};

StatusIcon.propTypes = {
    status: PropTypes.oneOf([
        'sending',
        'queued',
        'sent',
        'delivered',
        'read',
        'failed',
        'error',
    ]),
    updatedTimestamp: PropTypes.string,
};

StatusIcon.defaultProps = {
    status: undefined,
    updatedTimestamp: undefined,
};

export default StatusIcon;